// Bump this up when introducing a breaking change to the query object structure
export const VERSION = 2;

export enum ExploreMode {
    CREATE_EXPLORATION = 'createExploration',
    EDIT_EXPLORATION = 'editExploration',
    CREATE_QUERY = 'createQuery',
    EDIT_QUERY = 'editQuery'
}

/** @deprecated Use ExploreMode instead */
export const ExploreDialogMode = ExploreMode;

export interface ExploreColumn {
    name: string;
    type: string;
}

export interface ExploreFilter {
    column: ExploreColumn;
    operator: { name: string };
    value?: unknown;
    trimWhitespace?: boolean;
    caseSensitive?: boolean;
    isRelative?: boolean;
}

export interface ExploreDimension {
    column: ExploreColumn;
    bin?: number;
}

export interface ExploreMeasure {
    column: { name: string; isRowCount?: boolean };
    fn: string;
}

export interface ExploreSort {
    column: { name: string };
    direction: 'ASC' | 'DESC';
}

export interface ExploreQueryModel {
    version: number;
    queryUuid: string;
    table: string;
    index: number;
    name?: string;
    filters: ExploreFilter[];
    andOrOr?: string;
    sorts: ExploreSort[];
    limit: number | null;
    dimensions: ExploreDimension[] | null;
    measures: ExploreMeasure[];
    summaryFilters: ExploreFilter[];
    dimensionFilters?: Record<string, unknown>;
    skipRowCount?: boolean;
}
